export const model = {
    fields: {
        name: {
            isRequired: true
        },
        discountBase: {
            isRequired: true
        }
    }
}